<template>
  <div>
    <HeaderTabs
      :tabs-list="administrationTabs"
    />
    <SpinnerContainer
      v-if="appLoading"
      :is-loading="appLoading"
      class="nested-tab-page-spinner"
    />
    <router-view />
  </div>
</template>

<script>
  import HeaderTabs from 'components/common/HeaderTabs/HeaderTabs';
  import translation from 'translation';
  import {SpinnerContainer} from '@marilyn/marilyn-ui';
  import {mapGetters} from 'vuex';

  export default {
    name: 'AdministrationNestedPage',
    components: {HeaderTabs, SpinnerContainer},
    computed: {
      ...mapGetters('common', ['appLoading']),
      administrationTabs () {
        return [
          {
            id: 'users',
            title: translation.tr('Users'),
            to: {name: 'adminUsersList'}
          },
          {
            id: 'roles',
            title: translation.tr('Roles'),
            to: {name: 'adminRolesList'}
          },
          {
            id: 'billReport',
            title: translation.tr('Bill report'),
            to: {name: 'adminBillReport'}
          },
          {
            id: 'billReportSnapshot',
            title: translation.tr('Bill report snapshot'),
            to: {name: 'adminBillReportSnapshot'}
          },
          {
            id: 'collectstats',
            title: translation.tr('Collect statistics and web analytics'),
            to: {name: 'adminCollectStatisticsAndWebAnalytics'}
          }
        ];
      }
    }
  };
</script>
